import React, { memo } from 'react';
import { Formik, Form } from 'formik';
import { useTranslation } from 'react-i18next';
import TextField from '@material-ui/core/TextField';
import LoaderButton from '../../../shared/components/LoaderButton/LoaderButton';
import resendActivationCodeFormSchema from '../../schemas/resendActivationCodeFormSchema';
import styles from './resendActivationCodeForm.module.scss';

export default memo(function ResendEmail(props) {
    const { t } = useTranslation(['common', 'validations']);

    return (
        <div className={styles.container}>
            <Formik
                initialValues={{ Email: props.alternativeEmail }}
                validationSchema={resendActivationCodeFormSchema}
                onSubmit={values => props.resendVerificationCodeRequest(values.Email)}
                render={formProps => (
                    <Form>
                        <TextField
                            disabled={props.isResending || props.disabled}
                            error={formProps.touched.Email && !!formProps.errors.Email}
                            helperText={(formProps.touched.Email && !!formProps.errors.Email)
                                ? <span>{t('validations:INVALID_EMAIL')}</span>
                                : ''
                            }
                            label={t('common:EMAIL')}
                            name="Email"
                            onBlur={formProps.handleBlur}
                            onChange={formProps.handleChange}
                            type="email"
                            value={formProps.values.Email}
                        />
                        <LoaderButton
                            dictionary="common"
                            disabled={props.disabled}
                            inProgress={props.isResending}
                            text="RESEND"
                        />
                    </Form>
                )}
            />
        </div>
    );
}, (prevProps, nextProps) =>
        prevProps.isResending === nextProps.isResending &&
        prevProps.disabled === nextProps.disabled &&
        prevProps.alternativeEmail === nextProps.alternativeEmail &&
        prevProps.resendVerificationCodeRequest === nextProps.resendVerificationCodeRequest
);
